import {Pipe, PipeTransform} from '@angular/core';
import {Contact} from "../../model/contact";

@Pipe({
  name: 'afftectedToStartedContract',
  standalone: true,
})
export class AffectedToStartedContractPipe implements PipeTransform {

  transform(value: Contact[]): Contact[] {
    if (!value) {
      return value;
    }
    return value.filter((c: Contact) => {
      return c.contracts.some(contract => contract.status !== "Not Started");
    });
  }
}
